import { AuthController } from "@firecms/core";

// Role gating for the Apple Business Connect surface. Kept as two named lists so widening access is
// a one-line edit here rather than a hunt through collection definitions.
//
// Read: who can see the list of linked clients and answer "is this client linked?".
// Generate: who can produce a connect link. Narrower on purpose — this is the action with the
// wrong-account risk, since the CMS cannot validate an `accountId` (it lives in the dashboard
// project). See `cms/docs/apple-connect-link-design.md`.

export const GRANT_STATUS_VIEW_ROLES = ["admin", "csm"] as const;

export const CONNECT_LINK_GENERATE_ROLES = ["admin"] as const;

/**
 * Whether the signed-in user holds any of `allowedRoles`.
 *
 * ⚠️ `authController.extra` may be entirely absent: `services/auth.ts` falls back to allowing any
 * `@getdeardoc.com` address WITHOUT calling `setExtra`, so a legitimately signed-in user can have no
 * roles at all. Both `extra` and `roles` are therefore optional-chained — a roleless user is denied,
 * not crashed.
 */
export const hasAnyRole = (
  authController: AuthController,
  allowedRoles: readonly string[],
): boolean => {
  const roles: unknown = authController.extra?.roles;
  if (!Array.isArray(roles)) return false;
  return allowedRoles.some((role) => roles.includes(role));
};
